import ReactiveController from "phlex/reactive/reactive_controller";
import { registerControllers } from "stimulus-vite-helpers";
import { application } from "./application";

const controllers = import.meta.glob("./**/*_controller.js", { eager: true });
registerControllers(application, controllers);

// Register eagerly (not lazily) so a click immediately after page load is
// never missed — phlex-reactive ships one generic controller for all
// reactive components; the vite alias resolves it from the gem.
application.register("reactive", ReactiveController);
